import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

/**
 * Call slice — tracks the single active telehealth room.
 *
 * The video call is rendered ONCE at the app root (see GlobalZoomCall), not
 * inside any page. Pages open a call by dispatching startCall(roomId) and
 * never render the call widget themselves. That's what keeps a minimized
 * (PIP) call alive while the user navigates between pages — the iframe is
 * never unmounted by a route change. The End Call button clears the room via
 * endCall(), which is the only thing that tears the call down.
 */
interface CallState {
  /** Per-appointment room id of the active call, or null when no call is up. */
  activeRoom: string | null
}

const initialState: CallState = {
  activeRoom: null,
}

const callSlice = createSlice({
  name: 'call',
  initialState,
  reducers: {
    startCall(state, action: PayloadAction<string>) {
      state.activeRoom = action.payload
    },
    endCall(state) {
      state.activeRoom = null
    },
  },
})

export const { startCall, endCall } = callSlice.actions
export const callReducer = callSlice.reducer
